module.exports = __webpack_public_path__ + "static/img/ABUIABAEGAAg9_TjkQYo2Y-l7AUwgB44-AU.bb42bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABUIABAEGAAg9_TjkQYo2Y-l7AUwgB44-AU.png
// module id = cX1G
// module chunks = 1